import { render, staticRenderFns } from "./MeterChangeHistory.vue?vue&type=template&id=5b510b15&"
import script from "./MeterChangeHistory.vue?vue&type=script&lang=js&"
export * from "./MeterChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports